export default __webpack_public_path__ + "static/media/P348_CoC.bac8b113.pdf";